import React from 'react';
import { renderIconByLabel } from '../../content/icons';

export const ConditionLittle = props => {
  const { condition, updateField, canInteract = true } = props;
  const iconName = condition?.[condition?.state]?.icon;
  const iconElement = iconName
    ? renderIconByLabel(iconName, { size: 16 })
    : null;
  const label = condition?.[condition?.state]?.label;

  return (
    <div
      onClick={() =>
        canInteract &&
        updateField(
          condition.state === 'active' ? 'inactive' : 'active',
          'state'
        )
      }
      className={`flex items-center justify-center gap-03 rounded shadow px-1 pt-02 m-1 text-center uppercase font-condensed text-sm ${
        canInteract ? 'cursor-pointer transition hover:opacity-50' : 'cursor-default'
      } ${
        condition?.state === 'active' ? 'bg-secondary-d' : 'bg-primary'
      }`}
    >
      {iconElement && <span className='inline-flex'>{iconElement}</span>}
      {label}
    </div>
  );
};
